import {isCopilot} from '@github-ui/assignees/copilot-user'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {Author} from './commit-attribution-types'

export function shouldHideHovercard(author: Author | undefined): boolean {
  return isFeatureEnabled('copilot_hide_hovercard') && isCopilot(author?.login ?? '')
}

export function isBotOrApp(author: Author) {
  const isApp = author.path?.startsWith('/apps/') ?? false

  // Copilot SWE agent should be rendered as circular, not square
  if (isApp && author.login?.toLowerCase() === 'copilot-swe-agent') {
    return false
  }

  return isApp
}
